export const DISMISS_SPACE_SELECTOR = 'DISMISS_SPACE_SELECTOR';
export const OPEN_SPACE_SELECTOR = 'OPEN_SPACE_SELECTOR';
export const SELECT_SPACE_SELECTOR = 'SELECT_SPACE_SELECTOR';
export const SPACE_SELECTOR_TOGGLE_STAR = 'SPACE_SELECTOR_TOGGLE_STAR';
